function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Decimal from 'decimal.js';
import { BillingGroupTypes } from "../genServicesSummary";
import { serviceModel, relationshipModel } from "../../../models";
const BILLING_GROUP = [BillingGroupTypes.Today, BillingGroupTypes.OnEffectiveDate, BillingGroupTypes.InStages, BillingGroupTypes.Once, BillingGroupTypes.Weekly, BillingGroupTypes.BiWeekly, BillingGroupTypes.Monthly, BillingGroupTypes.Quarterly, BillingGroupTypes.Yearly];
function processServicesInGroup(services, allServices, serviceNameToIdMap, servicesInGroupBillingDetails, START_BILLING_AT) {
  const servicesByStartDate = new Map();
  const servicesWithoutStartDate = [];
  services.forEach(service => {
    var _servicesInGroupBilli;
    const serviceId = serviceNameToIdMap[service.name] || '';
    const originalService = allServices.find(s => s.id === serviceId);
    const serviceStartDate = originalService ? serviceModel.startBillingAt(originalService) : null;
    const priorPeriods = ((_servicesInGroupBilli = servicesInGroupBillingDetails[serviceId]) === null || _servicesInGroupBilli === void 0 ? void 0 : _servicesInGroupBilli.periods) || 0;
    if (serviceStartDate && priorPeriods === 0 && START_BILLING_AT) {
      const startDateKey = serviceStartDate.getTime().toString();
      if (!servicesByStartDate.has(startDateKey)) {
        servicesByStartDate.set(startDateKey, []);
      }
      servicesByStartDate.get(startDateKey).push(service);
    } else {
      servicesWithoutStartDate.push(service);
    }
  });
  return {
    servicesByStartDate,
    servicesWithoutStartDate
  };
}
function createBillingGroup(group, groupType, variablePrice, services, startDate) {
  const totalAmount = services.reduce((sum, service) => sum.plus(service.price), new Decimal(0));
  return {
    group: _objectSpread(_objectSpread({}, group), {}, {
      services,
      totalAmount,
      startDate
    }),
    groupType,
    variablePrice,
    startDate
  };
}
export function getBillingGroupTitle(groupType, startDate, relationship) {
  if (groupType === BillingGroupTypes.OnEffectiveDate && relationship) {
    return "Billed ".concat(groupType, " (").concat(relationshipModel.formatEffectiveDate(relationship), ")");
  }
  if (startDate) {
    const formattedStartDate = startDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    return "Billed ".concat(groupType, " starting on ").concat(formattedStartDate);
  }
  return "Billed ".concat(groupType);
}
export function processBillingGroups(billingSummary, allServices, serviceNameToIdMap, serviceBillingDetails, START_BILLING_AT) {
  const groups = [];
  BILLING_GROUP.forEach(groupType => {
    [false, true].forEach(variablePrice => {
      var _billingSummary$group;
      const group = (_billingSummary$group = billingSummary[groupType]) === null || _billingSummary$group === void 0 ? void 0 : _billingSummary$group.get(variablePrice);
      if (!group) return;

      // for "in stages" services, don't process by start date - they have their own stage timing
      if (groupType === BillingGroupTypes.InStages) {
        groups.push(createBillingGroup(group, groupType, variablePrice, group.services));
        return;
      }
      const {
        servicesByStartDate,
        servicesWithoutStartDate
      } = processServicesInGroup(group.services, allServices, serviceNameToIdMap, serviceBillingDetails, START_BILLING_AT);
      if (servicesWithoutStartDate.length > 0) {
        groups.push(createBillingGroup(group, groupType, variablePrice, servicesWithoutStartDate));
      }
      const sortedStartDateEntries = Array.from(servicesByStartDate.entries()).sort((_ref, _ref2) => {
        let [startDateKeyA] = _ref;
        let [startDateKeyB] = _ref2;
        return parseInt(startDateKeyA) - parseInt(startDateKeyB);
      });
      sortedStartDateEntries.forEach(_ref3 => {
        let [startDateKey, services] = _ref3;
        const startDate = new Date(parseInt(startDateKey));
        groups.push(createBillingGroup(group, groupType, variablePrice, services, startDate));
      });
    });
  });
  return groups;
}